import React, { useEffect, useMemo, useState } from "react";
import { Modal, message, Divider, Typography, Space, Tag,Button } from "antd";
import { MainTable } from "components";
import { instance } from "utils/axios";
import ImagePreviewer from "../wound_monitoring/ImagePreviewer"; 
import {
  CameraOutlined,
} from "@ant-design/icons";
const { Title } = Typography;

function CustomerHistory({ open = false, onClose, customerId }) {
  const [bookingData, setBookingData] = useState([]);
  const [surgeryData, setSurgeryData] = useState([]);
  const [woundData, setWoundData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
    const [photoUrl, setPhotoUrl] = useState(false);

  useEffect(() => {
    if (customerId && open) {
      fetchHistoryData(customerId);
    }
  }, [customerId, open]);

  const fetchHistoryData = (id) => {
    setLoading(true);
    instance({
      method: "get",
      url: `/customer/historyall?customerId=${id}`,
    })
      .then((res) => {
        const d = res?.data || {};
        // Анхны өгөгдөлгүй байвал хоосон массив болгож set хийнэ
        setBookingData(Array.isArray(d.booking) ? d.booking : []);
        setSurgeryData(Array.isArray(d.surgery) ? d.surgery : []);
        setWoundData(Array.isArray(d.wound) ? d.wound : []);
      })
      .catch(() => {
        message.error("Түүхийг авахад алдаа гарлаа");
      })
      .finally(() => setLoading(false));
  };

  // ------- Columns -------
  const bookingColumns = useMemo(
    () => [
      {
        title: "Огноо",
        dataIndex: "currentDateTime",
        key: "currentDateTime",
        width: 160,
      },
      {
        title: "Эмнэлэг",
        dataIndex: "hospital",
        key: "hospital",
        width: 180,
      },
      {
        title: "Төхөөрөмж",
        dataIndex: "ServiceType",
        key: "ServiceType",
        width: 120,
      },
      {
        title: "Шинжилгээ",
        dataIndex: "service",
        key: "service",
        width: 200,
        render: (text, row) => (
          <span>
            {text}
            {row?.isCe ? " +CE" : ""}
          </span>
        ),
      },
      {
        title: "CITO",
        dataIndex: "urgent",
        key: "urgent",
        width: 110,
        render: (v) => (v ? <Tag color="red">CITO</Tag> : <Tag>Энгийн</Tag>),
      },
    ],
   
  );

  // Surgery-д яг ямар талбар ирэх нь тодорхойгүй → өгөгдөл байвал динамик үүсгэнэ
  const surgeryColumns = useMemo(() => 
 [
        { title: "Огноо", dataIndex: "surgeryDate", key: "surgeryDate", width: 160 },
        { title: "Төрөл", dataIndex: "type", key: "type", width: 160 },
        { title: "Онош", dataIndex: "diagnose", operation: "diagnose", width: 160 },
        { title: "Ажиллагаа", dataIndex: "operation", operation: "type", width: 160 }, 
        { title: "Эмч", dataIndex: "doctor", key: "doctor", width: 180 },
      ]
 
 );

  const woundColumns = useMemo(
    () => [
      {
        title: "Огноо",
        dataIndex: "sessionDate",
        key: "sessionDate",
        width: 130,
      },
      {
        title: "Боолт хийсэн",
        dataIndex: "woundUser",
        key: "woundUser",
        width: 140,
      },
      {
        title: "Нэр",
        dataIndex: "firstname",
        key: "firstname",
        width: 160,
      },
      {
        title: "Зураг",
        dataIndex: "photoUrl",
        key: "photoUrl",
        width: 80,
        render: (photoUrl) => {
        return (
          <div className="flex items-center gap-5">
            <Button
              className={photoUrl!=null? "bg-green-600" : ""}
              disabled={photoUrl==null}
              size="small"
              onClick={() =>{ 
             
                setPhotoUrl(photoUrl)
                setPreviewOpen(true)}}
            >
              <div className="flex items-center gap-2 ">
                <CameraOutlined />
              </div>
            </Button>
          </div>
        )
      }
      },
      {
        title: "Хэвлийн гуурснаас нян судлалын шинжилгээ авсан эсэх",
        dataIndex: "catheterTestTaken",
        key: "catheterTestTaken",
        width: 160,
        render: (v) => (v ? "Тийм" : v === 0 ? "Үгүй" : "—"),
      },
      {
        title: "Хэвлийн гуурснаас нян судлалын үүсгэгч",
        dataIndex: "catheterPathogen",
        key: "catheterPathogen",
        width: 160,
        render: (v) => v ?? "—",
      },
      {
        title: "Шархнаас нян судлалын шинжилгээ авсан эсэх",
        dataIndex: "woundTestTaken",
        key: "woundTestTaken",
        width: 170,
        render: (v) => (v ? "Тийм" : v === 0 ? "Үгүй" : "—"),
      },
      {
        title: "Шархнаас үүсгэгч",
        dataIndex: "woundPathogen",
        key: "woundPathogen",
        width: 150,
        render: (v) => v ?? "—",
      },
      {
        title: "Гуурс авсан эсэх",
        dataIndex: "isCatheterRemoved",
        key: "isCatheterRemoved",
        width: 160,
        render: (v) => (v ? "Тийм" : v === 0 ? "Үгүй" : "—"),
      },
      {
        title: "Шинж тэмдэг",
        dataIndex: "labelNm",
        key: "labelNm",
        width: 160,
        render: (v) => v ?? "—",
      },
    ],
    []
  );

  return (
    <Modal
      title="Үйлчлүүлэгчийн түүх"
      open={open}
      onOk={onClose}
      onCancel={onClose}
      width={1200}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <div>
          <Title level={5} style={{ marginBottom: 8 }}>
            Шинжилгээ
          </Title>
          <MainTable
            dataTable={bookingData}
            columns={bookingColumns}
            loading={loading}
            title=""
          />
        </div>

        <Divider style={{ margin: "12px 0" }} />

        <div>
          <Title level={5} style={{ marginBottom: 8 }}>
            Мэс засал
          </Title>
          <MainTable
            dataTable={surgeryData}
            columns={surgeryColumns}
            loading={loading}
            title=""
          />
        </div>

        <Divider style={{ margin: "12px 0" }} />

        <div>
          <Title level={5} style={{ marginBottom: 8 }}>
            Боолт
          </Title>
          <MainTable
            dataTable={woundData}
            columns={woundColumns}
            loading={loading}
            title=""
          />
          <ImagePreviewer
            open={previewOpen}
            onClose={() => setPreviewOpen(false)}
            images={[`${process.env.REACT_APP_CDN_URL}${photoUrl}`]}
          />
        </div>
      </Space>
    </Modal>
  );
}

export default CustomerHistory;
